<kendo-progressbar [label]="$labelSettings()" [value]="$value()" />
